import { render } from "./POImainBanner.vue?vue&type=template&id=22dd70d4"
import script from "./POImainBanner.vue?vue&type=script&lang=js"
export * from "./POImainBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__